import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  getCourseDetails,
  replyToRating,
} from "../features/slices/courseDetails";
import userImg from "../assets/images/admin.png";
import { toastService } from "../utils/toastify";
const CourseRating = () => {
  const [ratingByAdmin, setRatingByAdmin] = useState("");
  const dispatch = useDispatch();
  const { state } = useLocation();
  useEffect(() => {
    if (state) dispatch(getCourseDetails({ id: state }));
  }, [state]);
  console.log(state);

  const { courseDetails, loading } = useSelector(
    (state) => state?.courseDetails
  );
  console.log({ courseDetails, loading });
  const [averageRating, setaverageRating] = useState(0);
  const [detailedRating, setDetailedRating] = useState([{}]);
  console.log(state, "statetrue");
  useEffect(() => {
    if (state) {
      const totalUser = courseDetails?.result?.[0]?.ratingData;
      const sumRating = courseDetails?.result?.[0]?.ratingData?.reduce(
        (acc, rating) => {
          return rating?.startCount ? acc + rating?.startCount : acc;
        },
        0
      );
      const obj = {};
      const average = sumRating / totalUser?.length || 0;
      console.log({ average, sumRating, totalUser: totalUser?.length });

      setaverageRating(Math.round(average));

      // Accumulate ratings in obj
      if (totalUser?.length > 0) {
        courseDetails?.result?.[0]?.ratingData?.forEach((rating) => {
          if (rating?.startCount in obj) {
            obj[rating?.startCount]++;
          } else {
            obj[rating?.startCount] = 1;
          }
        });

        // Calculate fullDetailRating after the loop completes
        const star = [
          ...new Set(
            courseDetails?.result?.[0]?.ratingData.map(
              (result) => result?.startCount || 0
            )
          ),
        ];

        const fullDetailRating = star?.map((str) => ({
          precentage: (obj[str] / totalUser?.length) * 100 || 0,
          star: str,
        }));

        console.log(fullDetailRating, "fulllllllllllllllllllllllllllll");
        setDetailedRating(fullDetailRating); // Set the full detail rating
      } else {
        setDetailedRating([]); // If no ratings, set an empty array (or object as needed)
      }
    }
  }, [state, courseDetails]);

  // console.log({ averageRating, detailedRating });
  const handleSubmit = (id) => {
    const data = {
      id,
      ratingByAdmin,
    };
    dispatch(replyToRating(data)).then((res) => {
      if (res?.payload?.code == 200) {
        dispatch(getCourseDetails({ id: state }));
        toastService.success("Reply to rating successfully");
        setRatingByAdmin("");
      } else {
        toastService.error("Reply to rating failed");
      }
    });
  };
  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="Small-Wrapper">
          <div className="TitleBox Border">
            <h4 className="Title">Rating and Reviews</h4>
          </div>
          <div className="LiveStreamAreaArea w-100">
            <div className="AverageReviewBox">
              <h4>Average Review</h4>
              <aside>
                <h5>{averageRating}</h5>

                <div className="Ratings">
                  {Array.from({ length: 5 }, (_, index) => {
                    return (
                      <span key={index}>
                        <i
                          className={
                            index < averageRating
                              ? "fa-solid fa-star checked"
                              : "fa-regular fa-star"
                          }
                        />
                      </span>
                    );
                  })}
                </div>

                <p>Rating</p>
              </aside>
            </div>
            <div className="ProgressBarArea Width">
              <h4>Detailed Rating</h4>

              <ul>
                {detailedRating.length > 0 ? (
                  detailedRating?.map((detailRat, i) => {
                    return (
                      <li key={i}>
                        <label>{detailRat?.precentage?.toFixed(2) || 0}%</label>
                        <div className="Ratings d-flex">
                          {Array.from({ length: 5 }, (_, index) => (
                            <span key={index}>
                              <i
                                className={
                                  index < detailRat?.star
                                    ? "fa-solid fa-star checked"
                                    : "fa-regular fa-star"
                                }
                              />
                            </span>
                          ))}
                        </div>
                        <div className="ProgressBar">
                          <span
                            className="Progress"
                            style={{
                              width: `${
                                detailRat?.precentage?.toFixed(2) || 0
                              }%`,
                            }}
                          />
                        </div>
                      </li>
                    );
                  })
                ) : (
                  <li>
                    <label>{0}%</label>
                    <div className="Ratings d-flex">
                      {Array.from({ length: 5 }, (_, index) => (
                        <span key={index}>
                          <i className="fa-regular fa-star" />
                        </span>
                      ))}
                    </div>
                    <div className="ProgressBar">
                      <span
                        className="Progress"
                        style={{
                          width: `0%`,
                        }}
                      />
                    </div>
                  </li>
                )}
              </ul>
            </div>
          </div>
          <div style={{ clear: "both" }} />
          <div className="RatingComment">
            {courseDetails?.result?.[0]?.ratingData
              ?.slice()
              ?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
              ?.map((data, i) => {
                return (
                  <article key={i}>
                    <aside>
                      <figure>
                        <img src={data?.user?.profilePic || userImg} />
                      </figure>
                      <figcaption>
                        <h6>{data?.user?.fullName}</h6>
                        <div className="Ratings">
                          {Array.from({ length: 5 }, (_, index) => (
                            <span key={index}>
                              <i
                                className={
                                  index < data?.startCount
                                    ? "fa-solid fa-star"
                                    : "fa-regular fa-star"
                                }
                              />
                            </span>
                          ))}
                        </div>
                      </figcaption>
                    </aside>
                    <p>{data?.comment}</p>
                    {data?.is_rating_admin ? (
                      <p className="reviewReply">{data?.ratingByAdmin}</p>
                    ) : (
                      <>
                        <div className="RatingForm ">
                          <div className="form-group">
                            <textarea
                              className="form-control"
                              placeholder="Make feedback here..."
                              rows={4}
                              defaultValue={""}
                              onChange={(e) => setRatingByAdmin(e.target.value)}
                            />
                          </div>
                        </div>
                        <button
                          className="Button"
                          onClick={() => handleSubmit(data?._id)}
                        >
                          Submit Row
                        </button>
                      </>
                    )}
                  </article>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseRating;
